export const pluralVypusk = (n: number): string => {
	const lastDigit = n % 10
	const lastTwo = n % 100
	if (lastDigit === 1 && lastTwo !== 11) {
		return 'випуск'
	}
	if (lastDigit >= 2 && lastDigit <= 4 && (lastTwo < 12 || lastTwo > 14)) {
		return 'випуски'
	}
	return 'випусків'
}
